module.exports = __webpack_public_path__ + "media/home2.c4970f41.mp4";